import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import SocialLinkRowItemLazy from './SocialLinkRowItemLazy';
import AppStoreLinkLazy from '../AppStoreLink/AppStoreLinkLazy';

import style from './SocialLinkRow-style.scss';

export const SocialLinkRowComponent = ({ items, viewer = {}, isClient }) => {
    return (
        <nav>
            {isClient && (
                <ul className={style.row}>
                    {items.map(item => {
                        return (
                            <React.Suspense fallback={''} key={item.name}>
                                <SocialLinkRowItemLazy {...item} />
                            </React.Suspense>
                        );
                    })}
                    {viewer.isDownloadAppEnabled && (
                        <div className={style.cell}>
                            <AppStoreLinkLazy />
                        </div>
                    )}
                </ul>
            )}
        </nav>
    );
};

SocialLinkRowComponent.propTypes = {
    items: PropTypes.array,
    isClient: PropTypes.bool,
    viewer: PropTypes.object,
};

export const SocialLinkRow = createFragmentContainer(SocialLinkRowComponent, {
    viewer: graphql`
        fragment SocialLinkRow_viewer on Viewer {
            isDownloadAppEnabled: isEnabledByLocale(featureName: "DOWNLOAD_APP")
        }
    `,
});
